/* Numiere — unified analytics
   ------------------------------------------------------------------
   Fires:  Google Analytics 4  •  Meta Pixel  •  TikTok Pixel  •  Google Ads
   Events: outbound_click (Buy on numiere.com)  •  view_item (PDP)
           form_submit (contact / newsletter)   •  bundle_interact (homepage builder)
   ------------------------------------------------------------------
   TO GO LIVE:  replace the four IDs in the CONFIG block below.
   Nothing else needs to change. */

(function () {
  // ============ 1. CONFIG — pulled from Shopify theme settings (Admin → Theme → Customize → Analytics) ============
  var injected = window.NUMIERE_ANALYTICS || {};
  var CFG = {
    GA4:        injected.GA4        || '',
    META:       injected.META       || '',
    TIKTOK:     injected.TIKTOK     || '',
    GADS:       injected.GADS       || '',
    GADS_LABEL: injected.GADS_LABEL || ''
  };
  var isPlaceholder = function (v) { return !v || /^\s*$/.test(v) || /XXX+/.test(v) || /^0+$/.test(v); };

  // ============ 2. Loaders ============
  // ---- GA4 + Google Ads (share gtag) ----
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());

  var gtagIds = [];
  if (!isPlaceholder(CFG.GA4))  gtagIds.push(CFG.GA4);
  if (!isPlaceholder(CFG.GADS)) gtagIds.push(CFG.GADS);
  if (gtagIds.length) {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtagIds[0];
    document.head.appendChild(s);
    gtagIds.forEach(function (id) { gtag('config', id, { send_page_view: true }); });
  }

  // ---- Meta Pixel ----
  if (!isPlaceholder(CFG.META)) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', CFG.META);
    fbq('track', 'PageView');
  }

  // ---- TikTok Pixel ----
  if (!isPlaceholder(CFG.TIKTOK)) {
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
      ttq.methods = ["page","track","identify","instances","debug","on","off","once",
        "ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat([].slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) { var e = ttq._i[t] || []; for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
      ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js"; var o = n && n.partner;
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
        ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var s = document.createElement("script"); s.type = "text/javascript"; s.async = !0;
        s.src = r + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(s, a);
      };
      ttq.load(CFG.TIKTOK); ttq.page();
    }(window, document, 'ttq');
  }

  // ============ 3. Unified event dispatcher ============
  function track(name, params) {
    params = params || {};
    try { if (window.gtag && gtagIds.length) gtag('event', name, params); } catch (e) {}
    try { if (window.fbq)                    fbq('trackCustom', name, params); } catch (e) {}
    try { if (window.ttq)                    ttq.track(name, params); } catch (e) {}
  }
  window.numiereTrack = track;

  // ============ 4. Auto-wire the four event types ============
  document.addEventListener('DOMContentLoaded', function () {

    // (a) Outbound "Buy on numiere.com" clicks — most important
    document.querySelectorAll('a[href*="numiere.com"]').forEach(function (a) {
      a.addEventListener('click', function () {
        var payload = {
          destination: a.href,
          product_handle: a.getAttribute('data-handle') || '',
          product_title:  a.getAttribute('data-title')  || (document.title || ''),
          value:  parseFloat(a.getAttribute('data-price') || '0') || undefined,
          currency: 'USD'
        };
        track('outbound_buy_click', payload);
        try { if (window.fbq) fbq('track', 'InitiateCheckout', { value: payload.value, currency: 'USD', content_name: payload.product_title }); } catch (e) {}
        try { if (window.ttq) ttq.track('ClickButton', { content_name: payload.product_title, value: payload.value, currency: 'USD' }); } catch (e) {}
        // Google Ads conversion (if configured)
        if (!isPlaceholder(CFG.GADS) && CFG.GADS_LABEL) {
          try { gtag('event', 'conversion', { send_to: CFG.GADS + '/' + CFG.GADS_LABEL, value: payload.value, currency: 'USD' }); } catch (e) {}
        }
      }, { passive: true });
    });

    // (b) Product page views — PDP is any <body data-pdp> OR any page with data-product-handle
    var pdp = document.body;
    var handle = pdp.getAttribute('data-product-handle') || '';
    var title  = pdp.getAttribute('data-product-title')  || '';
    var price  = parseFloat(pdp.getAttribute('data-product-price') || '0') || undefined;
    if (handle || pdp.hasAttribute('data-pdp')) {
      var viewPayload = { item_id: handle, item_name: title, value: price, currency: 'USD' };
      track('view_item', viewPayload);
      try { if (window.fbq) fbq('track', 'ViewContent', { content_ids: [handle], content_name: title, content_type: 'product', value: price, currency: 'USD' }); } catch (e) {}
      try { if (window.ttq) ttq.track('ViewContent', { content_id: handle, content_name: title, value: price, currency: 'USD' }); } catch (e) {}
    }

    // (c) Newsletter / contact form submits
    document.querySelectorAll('form').forEach(function (f) {
      f.addEventListener('submit', function () {
        var kind = f.getAttribute('data-form') || (f.querySelector('input[type=email]') ? 'newsletter' : 'contact');
        track('form_submit', { form_type: kind });
        try { if (window.fbq) fbq('track', 'Lead', { content_name: kind }); } catch (e) {}
        try { if (window.ttq) ttq.track('SubmitForm', { content_name: kind }); } catch (e) {}
      }, { passive: true });
    });

    // (d) Homepage bundle-builder interactions
    document.querySelectorAll('[data-bundle-add], [data-bundle-remove], .bundle-builder button, .bundle-builder [role=button]').forEach(function (el) {
      el.addEventListener('click', function () {
        var action = el.getAttribute('data-bundle-add') ? 'add' :
                     el.getAttribute('data-bundle-remove') ? 'remove' : 'interact';
        var item = el.getAttribute('data-handle') || el.getAttribute('data-title') || el.textContent.trim().slice(0, 60);
        track('bundle_interact', { action: action, item: item });
        if (action === 'add') {
          try { if (window.fbq) fbq('track', 'AddToCart', { content_name: item }); } catch (e) {}
          try { if (window.ttq) ttq.track('AddToCart', { content_name: item }); } catch (e) {}
        }
      }, { passive: true });
    });
  });
})();
